import React from "react";
import { connect } from "react-redux";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { IIdName } from "api/entities/id-name";
import { SHARD_CLUSTERS_ROUTE } from "constants/routes";
import { shardRepositoryActions } from "redux/actions/shard-repository";
import { IAppState } from "redux/reducers";
import { useNavigate } from "react-router-dom";
import { ConfirmDialog } from "components/shared-ui/dialogs/common/confirm-dialog/confirm-dialog";
import styles from "./delete-blocked-confirmation.module.scss";

const mapDispatchToProps = (
  dispatch: ThunkDispatch<IAppState, void, Action>
) => {
  return {
    closeConfirmation: () => {
      dispatch(shardRepositoryActions.deleteBlockedConfirmation.close());
    }
  };
};

const mapStateToProps = (state: IAppState) => ({
  isOpen: state.shardRepository.deleteBlockedConfirmation.isOpen,
  data: state.shardRepository.deleteBlockedConfirmation.data,
});

export interface IDeleteBlockedConfirmationData {
  storagePools?: IIdName<string>[];
}

export interface IDeleteBlockedConfirmationProps extends 
    ReturnType<typeof mapDispatchToProps>,
    ReturnType<typeof mapStateToProps> {
}

export const DeleteBlockedConfirmation = connect(mapStateToProps, mapDispatchToProps)((props: IDeleteBlockedConfirmationProps) => {
  const navigate = useNavigate();
  const storagePools = !!props.data && 'storagePools' in props.data && props.data.storagePools;

  const isSingleDependency = storagePools?.length === 1;
  const dependencyName = isSingleDependency ? 'Shard Cluster': 'Shard Clusters';

  function handleConfirm() {
    props.closeConfirmation();
    if (storagePools?.length) {
      navigate(SHARD_CLUSTERS_ROUTE, { state: { q: String(storagePools[0].name) } })
    }
  }

  function getUsedIn() {
    if (storagePools?.length > 1) {
      return (<>{storagePools?.length} different shard clusters: <strong>{storagePools.map(x => x.name).join(', ')}</strong></>);
    }
    if (storagePools?.length === 1) {
      return (<><strong>{storagePools[0].name}</strong> shard cluster</>);
    }
    return null;
  }

  return (
    <ConfirmDialog
      testId="delete-shard-repository-confirmation"
      title="Delete Shard Repository"
      confirmText={`View Linked ${dependencyName}`}
      open={props.isOpen}
      onClose={props.closeConfirmation}
      onConfirm={handleConfirm}
    >
      <div className={styles.content}>
          This shard repository is currently being used in {getUsedIn()}.
          If you still want to delete this Shard Repository, please delete {isSingleDependency ? 'the ' : ''}{dependencyName}.
      </div>
    </ConfirmDialog>
  );
});
